import React from 'react';
interface AvatarCalloutProps {
  name: string;
  quote: React.ReactNode;
}
export function AvatarCallout({
  name,
  quote
}: AvatarCalloutProps) {
  return <div className="bg-brand-cream border border-brand-goldLight border-l-4 border-l-brand-gold p-4 rounded mb-3 shadow-[0_2px_8px_rgba(0,0,0,0.06)] callout-hover" data-id="element-15">
      <div className="text-[13px] text-brand-gold font-medium uppercase tracking-[1px] mb-1.5" data-id="element-16">
        {name}
      </div>
      <p className="text-[14px] text-brand-navy font-normal leading-[1.6] m-0" data-id="element-17">
        {quote}
      </p>
    </div>;
}